module.exports = __webpack_public_path__ + "img/Tiu.2c47daa5.jpg";